class cAdminPurchases {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        var self = this;
        var elPurchaseTable = $("#purchase-table");
        $(elPurchaseTable).dataTable({
            'paging': true,
            'ordering': true,
            'info': true,
            'pageLength': 500,
            'lengthChange': true,
            'lengthMenu': [50, 100, 500, 700, 1000],
            'order': [[0, 'desc']],
            //Text translation options
            //Note the required keywords between underscores (e.g _MENU_)
            oLanguage: {
                sSearch: 'Search all columns:',
                sLengthMenu: '_MENU_ Sales per page',
                info: 'Showing page _PAGE_ of _PAGES_',
                zeroRecords: 'Nothing found - sorry',
                infoEmpty: 'No records available',
                infoFiltered: '(filtered from _MAX_ total records)'
            }
        });
    }
}
